import { Box, Dialog, DialogContent, DialogTitle, TextField } from '@material-ui/core';
import { BlueTickIcon, DialogCloseComponent, SearchIcon } from 'Components';
import { useLocalization } from 'Hooks';
import { AccountState, getStreetListRequest, storeAccount } from 'Stores/Account';
import { turkishCharacterNormalize } from 'Utils';
import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './DialogDistrict.scss';

export type districtItemProps = {
  kayitNo: number;
  mahalleAdi: string;
  mahalleKodu: number;
};

type DialogDistrictProps = {
  hide: () => void;
  isOpen: boolean;
  selectedValue?: any;
  setSelectedValue: Function;
};

const DialogDistrict: FC<DialogDistrictProps> = ({ hide, isOpen, selectedValue, setSelectedValue }) => {
  const { web_account_search } = useLocalization();
  const [searchKey, setSearchKey] = useState<string>('');

  const dispatch = useDispatch();

  const accountData: AccountState = useSelector(storeAccount);

  const districts: districtItemProps[] | undefined = accountData?.districtList;

  const itemClickHandle = (districtItem: districtItemProps) => {
    setSelectedValue(districtItem);
    dispatch(getStreetListRequest(districtItem.kayitNo.toString()));
    hide();
  };

  const onClose = () => {
    setSearchKey('');
    hide();
  };

  useEffect(() => {
    setSearchKey('');
  }, [hide]);

  return (
    <Dialog id="dialogDistrict" onClose={onClose} scroll="paper" keepMounted={false} open={isOpen}>
      <Box position="absolute" top={8} right={8} zIndex={2}>
        <DialogCloseComponent closeFunction={hide} />
      </Box>
      <DialogTitle className="dialogDistrict-search" style={{ paddingRight: 48 }}>
        <TextField
          label={web_account_search}
          variant="filled"
          value={searchKey}
          onChange={(e) => setSearchKey(e.currentTarget.value)}
          onKeyDown={(e)=>{
            if(e.key === 'Tab' && !e.shiftKey){
              const firstLi = document.querySelector<HTMLElement>(
                '#dialogDistrict .dialogDistrict-container__list li'
              );
              if(firstLi){
                e.preventDefault();
                firstLi.focus();
              }
            }
          }}
          InputProps={{
            endAdornment: <SearchIcon />,
          }}
          fullWidth
        />
      </DialogTitle>

      <DialogContent>
        <div className="dialogDistrict-container">
          <DistrictBlock
            districts={districts}
            searchKey={searchKey}
            selectedValue={selectedValue}
            lowerCaseSearchKey={searchKey.toLocaleLowerCase()}
            itemClickHandle={itemClickHandle}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

const DistrictBlock: FC<{
  districts: districtItemProps[] | undefined;
  searchKey: string;
  lowerCaseSearchKey: string;
  selectedValue?: string;
  itemClickHandle: Function;
}> = ({ districts, lowerCaseSearchKey, selectedValue, itemClickHandle }) => {
  return (
    <ul className="dialogDistrict-container__list" role="listbox">
      {!!districts &&
        districts.length > 0 &&
        districts
          .filter((item: districtItemProps) => {
            return turkishCharacterNormalize(item.mahalleAdi).includes(turkishCharacterNormalize(lowerCaseSearchKey));
          })
          .map((item: districtItemProps, index) => (
            <Item
              key={index}
              title={item.mahalleAdi}
              isSelected={item.mahalleAdi.toLocaleLowerCase('tr-TR') === selectedValue}
              onClick={() => itemClickHandle(item)}
            />
          ))}
    </ul>
  );
};

const Item: FC<{
  title: string;
  onClick: Function;
  isSelected: boolean;
}> = ({ title, onClick, isSelected }) => {
  return (
    <li 
      onClick={() => onClick()}
      aria-selected={isSelected}
      role="option"
      tabIndex={0}
      onKeyDown={(e)=>{
        if(e.key ==='Enter' || e.key === ' '){
          e.preventDefault();
          onClick();
        }
      }}
      onFocus={(e)=>e.currentTarget.scrollIntoView({block:'nearest'})}
      itemID="chooseAdressDistrictBtnTest">
      <div
        className={classNames({
          'dialogDistrict-container__list-item': true,
          'dialogDistrict-container__list-item--selected': isSelected,
        })}
      >
        <span className="input-text">{title.toLocaleLowerCase('tr-TR')}</span>
        {isSelected && <BlueTickIcon />}
      </div>
    </li>
  );
};

export default DialogDistrict;
